import { Link } from 'react-router'
import WatchCTA from '#app/routes/resources+/watch-cta.tsx'

export const meta = () => [{ title: 'JaseOwns - Gaming' }]

export default function Index() {
	return (
		<div className="container mx-auto text-black dark:text-white">
			<section id="gaming">
				<h1 className="text-3xl px-10 mb-8 text-cyan-900 dark:text-cyan-200">Gaming</h1>
				<p className="px-10 mb-8 text-xl">
					Got some stress to work out? <Link to="/pinata" className="underline">Whack the piñata</Link>.
				</p>
				<div className="justify-center mb-6 md:mb-12 text-xl px-10 flex flex-col space-y-6 md:space-y-0 md:space-x-16 md:flex-row">
					<div>
						<h2 className="text-2xl font-bold mb-2 md:mb-6">MMO</h2>
						<div><Link to="/gaming/ultima-online" className="underline">Ultima Online</Link></div>
						<div>Pantheon</div>
						<div><Link to="/gaming/everquest" className="underline">EverQuest</Link></div>
						<div><Link to="/gaming/everquest-legends" className="underline">EverQuest Legends</Link></div>
						<div>World of Warcraft</div>
						<div>Mortal Online (1, 2)</div>
					</div>
					<div>
						<h2 className="text-2xl font-bold mb-2 md:mb-6">RPG</h2>
						<div>Diablo Series (1, 2, 3, 4)</div>
						<div>Path of Exile</div>
						<div>Dungeon Siege</div>
						<div>Elder Scrolls</div>
					</div>
					<div>
						<h2 className="text-2xl font-bold mb-2 md:mb-6">Strategy</h2>
						<div>Warcraft Series (1, 2, 3)</div>
						<div>Starcraft Series (1, 2)</div>
						<div>League of Legends</div>
						<div>Tower defense games</div>
					</div>
					<div>
						<h2 className="text-2xl font-bold mb-2 md:mb-6">Survival</h2>
						<div>Conan Exiles</div>
						<div>Ark</div>
					</div>
					</div>
				<div className="justify-center mb-6 md:mb-12 text-xl px-10 flex flex-col space-y-6 md:space-y-0 md:space-x-16 md:flex-row">
					<div>
						<h2 className="text-2xl font-bold mb-2 md:mb-6">Shooters</h2>
						<div>Doom</div>
						<div>Quake</div>
						<div>PUBG</div>
						<div>Counterstrike</div>
					</div>
					<div>
						<h2 className="text-2xl font-bold mb-2 md:mb-6">Idle Games</h2>
						<div>Firestone</div>
						<div>AdVenture Capitalist</div>
						<div>Melvor Idle</div>
						<div>Bitburner</div>
						<div>Clicker Heroes</div>
						<div>IdleOn - The Idle MMO</div>
					</div>
					<div>
						<h2 className="text-2xl font-bold mb-2 md:mb-6">Sports</h2>
						<div>Rocket League</div>
						<div>FIFA</div>
					</div>
					<div>
						<h2 className="text-2xl font-bold mb-2 md:mb-6">Bullet Hell / Auto Shoot</h2>
						<div>Vampire Survivors</div>
						<div>Death Must Die</div>
						<div>Deep Rock Galactic: Survivor</div>
						<div>Soulstone Survivors</div>
					</div>
				</div>
				<h1 className="text-3xl px-10 mb-6 text-cyan-900 dark:text-cyan-200">Games with the most play time?</h1>
				<div className="justify-center text-xl px-10 flex flex-col space-y-6 md:space-y-0 md:space-x-16 md:flex-row">
					<div>Ultima Online</div>
					<div>Everquest</div>
					<div>Wow</div>
					<div>Firestone Idle</div>
					<div>Rocket League</div>
				</div>
			</section>


			<div className="flex flex-wrap justify-center gap-8 rounded-3xl py-4">
				{WatchCTA()}
			</div>
		</div>
	)
}


